/**
 * Palettes clair / sombre — source unique pour ThemeProvider.
 */
import { colors as lightColors } from './colors';

export const darkColors = {
  ...lightColors,
  secondary: lightColors.secondaryBlue,
  background: 'rgb(15, 23, 34)',
  backgroundLight: 'rgb(15, 23, 34)',
  cardBackground: 'rgb(26, 36, 51)',
  /* white reste blanc (texte bannière welcome, modales sur fond coloré) */
  text: 'rgb(232, 238, 248)',
  darkText: 'rgb(245, 247, 250)',
  textLight: 'rgb(168, 181, 201)',
  textSecondary: 'rgb(148, 163, 184)',
  textPrimary: 'rgb(255, 255, 255)',
  border: 'rgb(42, 58, 78)',
  borderFocus: 'rgba(0, 128, 255, 1)',
  overlayLight: 'rgba(10, 16, 28, 0.88)',
  overlayDark: 'rgba(0, 0, 0, 0.35)',
  sidebarBg: 'rgb(8, 12, 32)',
  primaryDark: 'rgb(12, 24, 72)',
  statusPlanned: 'rgb(20, 40, 68)',
  statusPlannedBg: 'rgb(20, 40, 68)',
  statusPlannedText: 'rgb(130, 190, 255)',
  statusInProgress: 'rgb(48, 36, 20)',
  statusInProgressBg: 'rgb(48, 36, 20)',
  statusInProgressText: 'rgb(255, 183, 77)',
  statusCompleted: 'rgb(20, 48, 28)',
  statusCompletedBg: 'rgb(20, 48, 28)',
  statusCompletedText: 'rgb(129, 199, 132)'
};

export const resolveThemeMode = (themePreference) => {
  const pref = String(themePreference || 'light').toLowerCase();
  if (pref === 'dark') return 'dark';
  if (pref === 'auto') {
    if (typeof window !== 'undefined' && window.matchMedia?.('(prefers-color-scheme: dark)').matches) {
      return 'dark';
    }
    return 'light';
  }
  return 'light';
};

export const getThemeColors = (mode) => (mode === 'dark' ? darkColors : lightColors);

export const buildStyledTheme = (themePreference) => {
  const mode = resolveThemeMode(themePreference);
  return {
    mode,
    themePreference: themePreference || 'light',
    colors: getThemeColors(mode)
  };
};

export { lightColors };
